import { ICandidateData } from "../types/candidates"

// TODO: make generic when needed
export function getColumnValueFromSearchNode(node: ICandidateData, searchId: string): string | number {
    if (!node) {
        return ''
    }

    if (node[searchId]) {
        return node[searchId]
    }

    // if value does not exist in top level of json object, look in customFields key under defaultValue
    return node?.customFields?.[searchId]?.defaultValue ?? ''
}